import { setupViewport } from "./viewport";
import { setupTenantSettings } from "./tenantSettings";
import { setupPostLogin } from "./postLoginSetup";
import { setupUnsavedChangesGuard } from "./unsavedChanges";
import { setupAnalytics } from "./analytics";
import { setupCrispChat } from "./crispChat";
import { setupFavicon } from "./favicon";

export function useBootstrap() {
  setupViewport();
  setupTenantSettings();
  setupPostLogin();
  setupUnsavedChangesGuard();
  setupAnalytics();
  setupCrispChat();
  setupFavicon();
}
